"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyPositionType = void 0;
var StickyPositionType;
(function (StickyPositionType) {
    StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
    StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
    StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
})(StickyPositionType || (exports.StickyPositionType = StickyPositionType = {}));
//# sourceMappingURL=Sticky.types.js.map